import React, { useEffect, useMemo, useState } from "react";
import {
  formatAppDateTime,
  getLiveTimeParts,
  prefers12HourClock,
} from "../../utils/appTimeFormat";

/** Local live clock for app headers (updates every second, shows seconds). */
const AppLiveClock = ({
  className = "app-chrome-clock",
  "aria-label": ariaLabel = "Current time",
  use12Hour = false,
}) => {
  const [now, setNow] = useState(() => new Date());
  const twelveHour = use12Hour ?? prefers12HourClock();

  useEffect(() => {
    const tick = () => setNow(new Date());
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);

  const parts = useMemo(() => getLiveTimeParts(now, twelveHour), [now, twelveHour]);
  const ariaTime = twelveHour
    ? `${parts.display12} ${parts.meridiem}`
    : parts.display24;

  return (
    <time
      className={className}
      dateTime={now.toISOString()}
      aria-label={`${ariaLabel}: ${ariaTime}`}
      title={formatAppDateTime(now, { use12Hour: twelveHour })}
    >
      <span className="app-live-clock-face" aria-hidden="true">
        {twelveHour ? (
          <>
            <span className="app-live-clock-part app-live-clock-hour">{parts.hours12}</span>
            <span className="app-live-clock-sep">:</span>
            <span className="app-live-clock-part">{parts.minutes}</span>
            <span className="app-live-clock-sep">:</span>
            <span className="app-live-clock-part app-live-clock-sec">{parts.seconds}</span>
            <span className="app-live-clock-meridiem">{parts.meridiem}</span>
          </>
        ) : (
          <>
            <span className="app-live-clock-part">{parts.hours24}</span>
            <span className="app-live-clock-sep">:</span>
            <span className="app-live-clock-part">{parts.minutes}</span>
            <span className="app-live-clock-sep">:</span>
            <span className="app-live-clock-part app-live-clock-sec">{parts.seconds}</span>
          </>
        )}
      </span>
    </time>
  );
};

export default AppLiveClock;
